var map = {
	"./apaym-ussd.png": "90fd",
	"./apaym.png": "3d30",
	"./ecobank-pay.png": "88ae",
	"./flooz-3.png": "f560",
	"./flooz.png": "0450",
	"./mastercard.png": "c210",
	"./momo-3.png": "d634",
	"./momo.png": "de2d",
	"./om-3.png": "44cb",
	"./om.png": "bfea",
	"./tresor-money.png": "496d",
	"./visa-qr 1.png": "4ce8",
	"./visa-qr 3.png": "f9ae",
	"./visa-qr 4.png": "990f",
	"./visa-qr-2.png": "b834",
	"./visa-qr.png": "851a",
	"./visa.png": "1de1",
	"./visa02.png": "f834",
	"./wave.png": "bc66"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6dc9";